<template>
    <div>
        <div class="flex items-center justify-center min-h-14 w-72" v-if="isLoading">
            <UIcon name="i-svg-spinners-90-ring-with-bg" class="w-8 h-8" />
        </div>
        <ul class="min-w-72 max-w-72" v-else>
            <li v-for="(item, index) in items" class="border-b py-4">
                <div class="flex gap-4">
                    <div class="w-1/4">
                        <div class="w-full aspect-square relative">
                            <UChip
                                inset
                                color="amazon"
                                size="2xl"
                                position="bottom-left"
                                :show="item.quantity > 0"
                                :text="item.quantity"
                                class="w-full h-full"
                                :ui="{ size: { '2xl': 'p-1.5 pt-2' } }"
                            >
                                <NuxtImg
                                    class="w-full h-full object-contain"
                                    :src="Object.values(item.product.feature_image)[0].original_url"
                                    preset="thumbnail"
                                    sizes="sm:120px md:80px"
                                    placeholder
                                />
                            </UChip>
                        </div>
                    </div>
                    <div class="w-3/4 flex gap-2">
                        <div class="grow">
                            <UiComponentTypography class="text-right" variant="h6">
                                {{ item.product.name }}
                            </UiComponentTypography>
                            <ul class="flex gap-2 mt-1">
                                <li v-for="(el, i) in item.variant.items">
                                    <UiComponentTypography class="text-right" variant="body2">
                                        {{ el.value }}
                                        <span v-if="i < (item.variant.items?.length ?? 0) - 1">/</span>
                                    </UiComponentTypography>
                                </li>
                            </ul>
                            <div class="flex items-end justify-end">
                                <WidgetsProductPrice
                                    v-if="item.product.is_in_stock"
                                    class="justify-end items-end"
                                    size="md"
                                    :price="calculatePrice(item.price).price"
                                    :discount="calculatePrice(item.price).discounted_price"
                                />
                                <UiComponentTypography
                                    v-else
                                    variant="caption"
                                    class-name="text-rose-500 bg-rose-50 py-1 px-4 rounded-md mt-4"
                                >
                                    ناموجود
                                </UiComponentTypography>
                            </div>
                        </div>
                        <div class="flex justify-center items-start">
                            <UButton
                                size="xs"
                                icon="i-solar-trash-bin-minimalistic-line-duotone"
                                variant="ghost"
                                color="rose"
                                :padded="false"
                                @click="handleRemove(item.id, index)"
                                :loading="isLoadingItems.includes(index)"
                            />
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div class="flex justify-center sticky bottom-0 w-full p-4 left-0 bg-white">
            <UButton size="xs" to="/cart"> مشاهده سبد خرید </UButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ICart } from "~/libs/types/api/cart";

const emits = defineEmits(["update:pending", "update:idle"]);

const props = defineProps({
    items: Array as PropType<ICart[]>,
    isLoading: Boolean,
});

const isLoadingItems: Ref<number[]> = ref([]);

const cart = useCartStore();

async function handleRemove(id: number, index: number) {
    if (isLoadingItems.value.length === 0) emits("update:pending");
    isLoadingItems.value.push(index);
    await cart.remove(id);
    isLoadingItems.value = isLoadingItems.value.filter((i) => i != index);
    if (isLoadingItems.value.length === 0) emits("update:idle");
}
</script>

<style></style>
